import React, { FC } from 'react';
import { Skeleton } from '@mui/material';
import { Grid } from '@mui/material';

import styles from './WiseSkeletons.module.scss';

// Skeleton pojedynczej karty produktu (grid)
export const WiseProductItemSkeleton: FC = () => (
  <div className={styles.productCard}>
    <Skeleton variant="rectangular" className={styles.productImage} />
    <div className={styles.productBody}>
      <Skeleton variant="text" width="60%" height={14} />
      <Skeleton variant="text" width="80%" height={20} />
      <Skeleton variant="text" width="50%" height={14} />
      <div className={styles.productFooter}>
        <div>
          <Skeleton variant="text" width={80} height={28} />
          <Skeleton variant="text" width={60} height={16} />
        </div>
        <Skeleton variant="rectangular" width={44} height={44} className={styles.cartBtn} />
      </div>
    </div>
  </div>
);

// Skeleton wiersza produktu (line)
export const WiseProductLineSkeleton: FC = () => (
  <div className={styles.productLine}>
    <Skeleton variant="rectangular" className={styles.productLineImage} />
    <div className={styles.productLineBody}>
      <Skeleton variant="text" width="40%" height={20} />
      <Skeleton variant="text" width="25%" height={14} />
    </div>
    <div className={styles.productLineActions}>
      <Skeleton variant="text" width={80} height={28} />
      <Skeleton variant="rectangular" width={44} height={44} className={styles.cartBtn} />
    </div>
  </div>
);

// Skeleton mobilnej karty produktu
export const WiseMobileProductItemSkeleton: FC = () => (
  <div className={styles.productCard}>
    <Skeleton variant="rectangular" className={styles.productImage} />
    <div className={styles.productBody}>
      <Skeleton variant="text" width="90%" height={18} />
      <Skeleton variant="text" width="70%" height={18} />
      <Skeleton variant="text" width="40%" height={14} />
      <Skeleton variant="text" width="50%" height={14} style={{ marginTop: 6 }} />
      <div className={styles.mobileOrderRow}>
        <Skeleton variant="rectangular" height={44} className={styles.mobileUnit} />
        <Skeleton variant="rectangular" width={100} height={44} className={styles.cartBtn} />
      </div>
      <div className={styles.productFooter}>
        <div>
          <Skeleton variant="text" width={100} height={28} />
          <Skeleton variant="text" width={70} height={16} />
        </div>
        <Skeleton variant="rectangular" width={44} height={44} className={styles.cartBtn} />
      </div>
    </div>
  </div>
);

// Szkielet siatki produktów
interface IProductsSkeletonProps {
  count?: number;
  line?: boolean;
  isTablet?: boolean;
  isMobile?: boolean;
}

export const WiseProductsGridSkeleton: FC<IProductsSkeletonProps> = ({
  count = 8,
  line = false,
  isTablet = false,
  isMobile = false
}) => (
  <>
    {Array.from({ length: count }).map((_, i) =>
      isMobile ? (
        <Grid key={i} item xs={12}>
          <WiseMobileProductItemSkeleton />
        </Grid>
      ) : line ? (
        <Grid key={i} item md={12}>
          <WiseProductLineSkeleton />
        </Grid>
      ) : (
        <Grid key={i} item md={isTablet ? 4 : 3}>
          <WiseProductItemSkeleton />
        </Grid>
      )
    )}
  </>
);

// Skeleton listy kategorii
export const WiseCategoriesSkeleton: FC = () => (
  <div className={styles.categoriesSkeleton}>
    {Array.from({ length: 7 }).map((_, i) => (
      <div key={i} className={styles.categoryRow}>
        <Skeleton variant="circular" width={14} height={14} />
        <Skeleton variant="text" width={`${60 + (i % 3) * 15}%`} height={16} />
      </div>
    ))}
  </div>
);

// Skeleton filtrów w sidebarze
export const WiseFiltersSidebarSkeleton: FC = () => (
  <div className={styles.filtersSkeleton}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Skeleton key={i} variant="rectangular" height={42} className={styles.filterSelect} />
    ))}
  </div>
);
